import type { FontSize } from 'apps/core/types/global.types';

const fontSize: FontSize = {
  textXs: '0.75rem',
  textSm: '0.875rem',
  textBase: '0.938rem',
  textLg: '1.125rem',
  textXl: '1.25rem',
  text2xl: '1.563rem',
  text3xl: '1.875rem',
  text4xl: '2.25rem',
  text5xl: '3rem',
};

export default fontSize;
